import { db } from "../firebase-app";
import { Module } from "vuex";
import {
  collection,
  deleteDoc,
  doc,
  DocumentData,
  getDoc,
  onSnapshot,
  query,
  updateDoc,
} from "firebase/firestore";
import store from ".";
import { getStorage, listAll, deleteObject, ref as storageRef } from "firebase/storage";

const modProjects: Module<any, any> = {
  namespaced: true,
  state: {
    userProjects: [] as any[],
    selectedProject: null as any,
    projectSnapshot: null as any,
    selectedProjectId: String || null,
    showScriptTags: false,
    documentationInServer: "",
    documentationInClient: "",

    firstSnapshot: true,
  },
  mutations: {
    setProjectSnapshot(state, value) {
      state.projectSnapshot = value
    },
    setSelectedProject(state, value) {
      state.selectedProject = value
    },

    setShowScriptTags(state, value) {
      state.showScriptTags = value;
    },
    setSelectedProjectId(state, projectId) {
      state.selectedProjectId = projectId;
    },
    setUserProjects(state, projects) {
      state.userProjects = projects;
    },
    setFirstSnapshot(state, value) {
      state.firstSnapshot = value
    },
  },
  getters: {
    getUserProjects(state): any[] | null {
      console.log("getting user projects: ", state.userProjects);
      return state.userProjects;
    },
  },
  actions: {
    async fetchUserProjects({ state, commit }, userId) {
      const projectsRef = collection(db, `users/${userId}/projects`);
      onSnapshot(projectsRef, (querySnapshot) => {
        const projects: DocumentData[] = [];
        querySnapshot.forEach((doc) => {
          projects.push(doc.data());
        });
        commit("setUserProjects", projects);
      });
    },
    getProject({ rootGetters, commit, state }, projectId) {
      if (state.projectSnapShot) {
        state.projectSnapShot();
      }


      const user = rootGetters["modLogin/currentUser"];
      const projectRef = doc(db, `users/${user.uid}/projects`, projectId);
      commit("setProjectSnapshot", onSnapshot(projectRef, (snapshot) => {

        const projectData: any = {
          id: snapshot.id,
          ...snapshot.data(),
        }
        commit("setSelectedProject", projectData);
        if (state.firstSnapshot) {
          commit("setFirstSnapshot", false)
          console.log("project first snapshot");
        }
      }));

    },
    async deleteProject({ rootGetters }, project) {
      store.commit("setAppIsLoading", true);
      const user = rootGetters["modLogin/currentUser"];
      const projectRef = doc(db, `users/${user.uid}/projects`, project.name);
      await deleteDoc(projectRef);
      // delete storage related to the project
      const storage = getStorage();
      const projectDevScriptsRef = storageRef(storage, `scripts/${project.slug}/dev`);
      try {
        const listResult = await listAll(projectDevScriptsRef);
        const deletePromises = listResult.items.map((item) => deleteObject(item));
        await Promise.all(deletePromises);
      } catch (error) {
        console.error("Error deleting project script files:", error);
      }
      const projectProdScriptsRef = storageRef(storage, `scripts/${project.slug}/prod`);
      try {
        const listResult = await listAll(projectDevScriptsRef);
        const deletePromises = listResult.items.map((item) => deleteObject(item));
        await Promise.all(deletePromises);
      } catch (error) {
        console.error("Error deleting project script files:", error);
      }
      store.commit("setAppIsLoading", false);
    },
    // update project
    async updateProject({ rootGetters }, { projectId, updates }) {
      const user = rootGetters["modLogin/currentUser"];
      const projectRef = doc(db, `users/${user.uid}/projects`, projectId);
      await updateDoc(projectRef, updates);
    },
  },
};
export default modProjects;
